import { ApplicationConfig, provideBrowserGlobalErrorListeners } from '@angular/core';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { provideRouter, withInMemoryScrolling } from '@angular/router';

import { routes } from './app.routes';
import { authHeaderInterceptor } from '../shared/interceptors/auth-header.interceptor';
import { authErrorInterceptor } from '../shared/interceptors/auth-error.interceptor';
import { ngrokSkipWarningInterceptor } from '../shared/interceptors/ngrok-skip-warning.interceptor';

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    // ngrokSkipWarningInterceptor va primero: solo agrega un header y no
    // decide nada sobre la petición, así que da igual el orden respecto a los
    // otros dos - se pone primero por prolijidad (headers "de transporte"
    // antes que los de identidad/manejo de errores).
    provideHttpClient(withInterceptors([ngrokSkipWarningInterceptor, authHeaderInterceptor, authErrorInterceptor])),
    provideRouter(
      routes,
      withInMemoryScrolling({ scrollPositionRestoration: 'top' })
    )
  ]
};
